import React from 'react';
import './App.css';
import Profile from '../src/components/Profile.js'
import Icons from '../src/components/Icons.js'

function App() {
  return (
    <div className="App">
     <Profile/>
     <Icons/>
    </div>
  );
}

export default App;